/* eslint-disable react/no-find-dom-node */
import { BaseComponent } from "./BaseComponent";

import { IValidatable } from "./Validation/IValidatable";

import { object } from "prop-types";
import * as ReactDOM from "react-dom";
import { Scroll } from "../Utils/Scroll";

export abstract class FormComponent<TProps, TState> extends BaseComponent<TProps, TState> implements IValidatable {
    public static childContextTypes: React.ValidationMap<any> = {
        formElement: object.isRequired,
    };

    private _inputs: IValidatable[] = [];
    constructor(props: TProps) {
        super(props);
    }

    public abstract render(): JSX.Element;

    public getChildContext(): any {
        return {
            formElement: {
                attachToForm: (input: IValidatable) => this.attachToForm(input),
                detachFromForm: (input: IValidatable) => this.detachFromForm(input),
            },
        };
    }

    public setDisable() {
        this._inputs.forEach((input) => {
            input.setDisable();
        });
    }

    public isValid(): boolean {
        let valid = true;
        let firstError: Element = null;
        this._inputs.forEach((input) => {
            if (!input.isValid()) {
                valid = false;
                if (firstError == null) {
                    firstError = ReactDOM.findDOMNode(input as any) as Element;
                }
            }
        });

        if (firstError) {
            Scroll.focusElement(firstError);
        }

        return valid;
    }

    private attachToForm(input: IValidatable): void {
        if (this._inputs.indexOf(input) !== -1) {
            return;
        }

        this._inputs.push(input);
    }

    private detachFromForm(input: IValidatable): void {
        const inputPos = this._inputs.indexOf(input);
        if (inputPos === -1) {
            return;
        }

        this._inputs = [...this._inputs.slice(0, inputPos), ...this._inputs.slice(inputPos + 1)];
    }
}

/*
NOTE: Alternative approach which does not use context, but traverses all childeren of formComponent
    and sets attachToForm and detachFromForm props of all components that implement IValidatable
    - thus have these properties:

    private registeredInputs = new Array<IValidatable>();

    public componentWillMount() {
        this.registerInputs(this as any);
    }

    private registerInputs(elem: React.ReactElement<React.Props<any>>) {

        React.Children.forEach(elem.props.children, (child: any) => {

            if (!child.hasOwnProperty('props')) {
                return null;
            }

            if (child.type.prototype && child.type.prototype.isValid && typeof (child.type.prototype.isValid) == 'function') {
                console.log(child);
                child.props.addedProp = true;
                child.props.attachToForm = (input: IValidatable) => this.attachToForm(input);
                child.props.detachFromForm = (input: IValidatable) => this.detachFromForm(input);
            }

            this.registerInputs(child);
        });
    }

    private attachToForm(input: IValidatable) {
        this.registeredInputs.push(input);
    }

    private detachFromForm(input: IValidatable) {
        let index = this.registeredInputs.indexOf(input);
        this.registeredInputs.splice(index, 1);
    }
*/
